function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Error } from 'module-tsl-ui-elements';
import { Field } from 'formik';

var CustomFileUpload = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomFileUpload, _React$Component);

  var _super = _createSuper(CustomFileUpload);

  function CustomFileUpload(props) {
    var _this;

    _classCallCheck(this, CustomFileUpload);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFileChange", function (e) {
      var onChange = _this.props.field.onChange;
      var file = e.target.files[0];
      if (!file) return;

      _this.setState({
        uploading: true
      });

      if (file.size > _this.file.maxSize) {
        return _this.setState({
          uploading: false,
          uploadError: true,
          errorMessage: 'File is too big, max file size is 5MB'
        });
      }

      _this.props.handleFileUpload(file).then(function () {
        return _this.setState({
          fileName: file.name,
          uploading: false,
          uploadError: false
        });
      })["catch"](function (err) {
        return _this.setState({
          uploading: false,
          uploadError: true,
          errorMessage: err
        });
      });

      onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      _this.fileInput.click();
    });

    _this.fileInput = null;
    _this.state = {
      fileName: 'No file selected',
      uploading: false,
      uploadError: false,
      errorMessage: ''
    }; // https://stripe.com/docs/file-upload

    _this.file = {
      maxSize: 5 * 1024 * 1024,
      mimeTypes: 'image/png, image/jpeg'
    };
    return _this;
  }

  _createClass(CustomFileUpload, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          fileName = _this$state.fileName,
          uploading = _this$state.uploading,
          uploadError = _this$state.uploadError,
          errorMessage = _this$state.errorMessage;
      var _this$props = this.props,
          name = _this$props.field.name,
          _this$props$form = _this$props.form,
          touched = _this$props$form.touched,
          errors = _this$props$form.errors,
          submitCount = _this$props$form.submitCount;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "upload-section"
      }, /*#__PURE__*/React.createElement("input", {
        name: name,
        multiple: false,
        accept: this.file.mimeTypes,
        type: "file",
        ref: function ref(inst) {
          _this2.fileInput = inst;
        },
        className: "hide",
        onChange: this.onFileChange
      }), /*#__PURE__*/React.createElement(Button, {
        type: "button",
        theme: "currentColor",
        onClick: this.handleUploadClick,
        loading: uploading
      }, "Upload file"), /*#__PURE__*/React.createElement("p", {
        className: "upload-section__text"
      }, fileName)), uploadError && /*#__PURE__*/React.createElement(Error, {
        error: errorMessage
      }), (touched[name] || Boolean(submitCount)) && /*#__PURE__*/React.createElement(Error, {
        error: errors[name]
      }));
    }
  }]);

  return CustomFileUpload;
}(React.Component);

CustomFileUpload.displayName = "CustomFileUpload";
CustomFileUpload.propTypes = {
  handleFileUpload: PropTypes.func.isRequired,
  field: PropTypes.objectOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func
  })).isRequired,
  form: PropTypes.objectOf(PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    submitCount: PropTypes.number
  })).isRequired
};

var EnhancedFileUpload = function EnhancedFileUpload(props) {
  return /*#__PURE__*/React.createElement(Field, _extends({
    component: CustomFileUpload
  }, props));
};

EnhancedFileUpload.displayName = "EnhancedFileUpload";
export default EnhancedFileUpload;